module.exports = __webpack_public_path__ + "static/img/14000397.98718293.png";